<template>

    <v-card color="#f5f5f5" v-observe-visibility="visibilityChanged">

        <!--DELETE - Dialog-->
        <v-dialog
                persistent
                v-model="deleteDialog" max-width="400px">
            <v-card>
                <v-card-title>
                    <span class="headline">Delete Supplier?</span>
                </v-card-title>

                <v-card-text>
                    <v-layout v-if="loading" row pt-4 pb-4 pr-4 pl-4>
                        <v-flex xs12>
                            <v-card-title class="headline">Deleting supplier...</v-card-title>
                        </v-flex>
                        <v-flex justify-end>
                            <v-progress-circular
                                    :size="70"
                                    :width="7"
                                    color="primary"
                                    indeterminate
                            ></v-progress-circular>
                        </v-flex>
                    </v-layout>
                    <v-form v-if="!loading" ref="form" v-model="deleteFormValidation" lazy-validation>
                        <v-checkbox
                                :rules="[v => !!v || 'You have to check this to continue!']"
                                required
                                v-model="deleteChecked" color="primary"
                                label="Do you really want to delete this supplier?"></v-checkbox>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-1" flat @click.native="cancelDeleteDialog()">CANCEL</v-btn>
                    <v-btn color="primary darken-1" flat @click.native="deleteSupplier()">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-toolbar light color="white">
            <v-btn icon @click.native="closeNewSupplierDialog" light>
                <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title v-if="selectedSupplier.id === 0">Add New Supplier</v-toolbar-title>
            <v-toolbar-title v-else>Edit Supplier - {{selectedSupplier.name}}</v-toolbar-title>
            <v-spacer></v-spacer>

            <v-toolbar-items>
                <v-menu
                        transition="slide-y-transition"
                        :nudge-bottom="20"
                        :nudge-right="0"
                        :nudge-left="0">
                    <v-btn @click="openBottomSheet($vuetify.breakpoint.mdAndDown)" id="menu-button"
                           slot="activator"
                           icon>

                        <v-icon dark>more_vert</v-icon>

                    </v-btn>
                    <v-list v-show="$vuetify.breakpoint.lgAndUp">
                        <v-list-tile @click.native="saveAll()">
                            <v-list-tile-title>
                                <v-icon color="secondary">save</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click.native="showDeleteDialog()">
                            <v-list-tile-title>
                                <v-icon color="red">delete</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-toolbar-items>

        </v-toolbar>

        <v-tabs
                v-model="activeTab"
                color="secondary"
                dark
                slider-color="primary"
        >
            <v-tab>Supplier</v-tab>

            <v-tab-item>
                <v-layout wrap>
                    <v-flex xs12 xl4 offset-xl4 offset-md2 md6 mt-5 pa-2>
                        <v-hover>
                            <v-card
                                    slot-scope="{ hover }"
                                    :class="`elevation-${hover ? 4 : 1}`">
                                <v-card-text>
                                    <v-container grid-list-md>
                                        <v-layout wrap>
                                            <v-flex xs12>
                                                <v-layout wrap>
                                                    <v-flex xs12>
                                                        <span class="title">General</span>
                                                        <v-divider></v-divider>
                                                    </v-flex>
                                                    <v-flex xs12 mt-4>
                                                        <v-text-field
                                                                v-model="selectedSupplier.name"
                                                                label="Name">
                                                        </v-text-field>
                                                    </v-flex>

                                                </v-layout>

                                                <v-layout wrap mt-4>
                                                    <v-flex xs12>
                                                        <span class="title">Optional Info</span>
                                                        <v-divider></v-divider>
                                                    </v-flex>

                                                    <v-flex xs12 mt-4>
                                                        <v-text-field
                                                                v-model="selectedSupplier.website"
                                                                label="Website">
                                                        </v-text-field>
                                                    </v-flex>

                                                    <v-flex xs12>
                                                        <v-text-field
                                                                v-model="selectedSupplier.email"
                                                                label="E-Mail">
                                                        </v-text-field>
                                                    </v-flex>

                                                </v-layout>

                                                <v-layout mt-5 row justify-end>
                                                    <v-btn mt-5 dark color="secondary"
                                                           @click.native="saveSupplierAndGoToNextTab(1)">
                                                        Save
                                                        <v-icon class="white--text" right>save</v-icon>
                                                    </v-btn>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </v-hover>
                    </v-flex>
                </v-layout>
            </v-tab-item>

            <!--Branch office settings-->
            <v-tab :disabled="branchOfficeTabActive">Branch Offices</v-tab>
            <v-tab-item>
                <branch-offices></branch-offices>
            </v-tab-item>

            <!--New Contact persons-->
            <v-tab :disabled="contactPersonsTabActive">Contact Persons</v-tab>
            <v-tab-item>
                <contact-persons></contact-persons>
            </v-tab-item>

            <!--Bank accounts settings-->
            <v-tab :disabled="bankAccountsTabActive">Bank Accounts</v-tab>
            <v-tab-item>
                <bank-accounts></bank-accounts>
            </v-tab-item>

            <!--Manufacturer Settings-->
            <v-tab :disabled="manufacturerTabActive">Manufacturers</v-tab>
            <v-tab-item>
                <branch-offices-manufacturers></branch-offices-manufacturers>
            </v-tab-item>

        </v-tabs>

    </v-card>

</template>


<script>
    import {Settings} from '../../store/namespace-helper'
    import BranchOffices from '../Settings/Suppliers/BranchOffices.vue'
    import ContactPersons from '../Settings/Suppliers/ContactPersons.vue'
    import BankAccounts from '../Settings/Suppliers/BankAccounts.vue'
    import BranchOfficesManufacturers from '../Settings/Suppliers/BranchOfficesManufacturers.vue'

    export default {
      components: {
        ContactPersons,
        BranchOffices,
        BankAccounts,
        BranchOfficesManufacturers
      },
      name: 'add-new-supplier',
      data () {
        return {
          activeTab: 0,
          deleteFormValidation: false,
          deleteDialog: false,
          deleteChecked: false,
          countries: this.$store.getters.countries,
          salutions: [
            'Mr.',
            'Mrs.',
            'Company'
          ],
          isVisible: false,
          supplierContact: {},
          supplier_id: this.selectedSupplier,
          supplierUpdated: 0,
          onDismissed: false,
          sheet: false
        }
      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
              console.log('tab visible, load data')
                        // this.loadSupplierContacts();
              this.loadSupplierBankAccounts()
              this.loadSupplierBranchOffices()
            } else {
              this.supplierUpdated = 0
            }
          }
        },
        closeNewSupplierDialog () {
          this.$store.dispatch(Settings.actions.setSelectedSupplier, null)
          this.$store.dispatch(Settings.actions.setBranchOffices, null)
          this.$store.dispatch(Settings.actions.setSelectedBranchOffice, null)
          this.$store.dispatch(Settings.actions.openCloseNewSupplierDialog)
          this.activeTab = 0
        },
        loadSupplierContacts () {
          this.$store.dispatch(Settings.actions.loadSupplierContacts, this.supplier_id)
        },
        loadSupplierBankAccounts () {
          this.$store.dispatch(Settings.actions.loadBranchOfficeBankAccounts, this.supplier_id)
        },
        loadSupplierBranchOffices () {
          this.$store.dispatch(Settings.actions.loadSupplierBranchOffices, this.selectedSupplier.id)
        },
        saveSupplierAndGoToNextTab (index) {
          this.$store.dispatch(Settings.actions.createSupplier, this.selectedSupplier)
          this.activeTab = index
        },
        openBottomSheet (payload) {
          if (payload) {
            this.$store.dispatch('openCloseBottomSheet')
          }
        },
        showDeleteDialog () {
          this.deleteDialog = true
        },
        cancelDeleteDialog () {
          this.deleteDialog = false
          this.deleteChecked = false
        },
        deleteSupplier () {
          if (!this.$refs.form.validate()) {
            return
          }
          this.$store.dispatch(Settings.actions.removeSupplier, this.selectedSupplier).then(response => {
            this.closeNewSupplierDialog()
            this.deleteChecked = false
          })
        }
      },
      computed: {
        dialog () {
          return this.$store.getters[Settings.getters.getOpenNewSupplierDialogState]
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        selectedSupplier () {
          console.log('selected supplier: ' + JSON.stringify(this.$store.getters[Settings.getters.getSelectedSupplier]))
          return this.$store.getters[Settings.getters.getSelectedSupplier]
        },
        supplierContacts () {
          return this.$store.getters[Settings.getters.getSupplierContacts]
        },
        supplierBankAccounts () {
          return this.$store.getters[Settings.getters.supplierBankAccounts]
        },
        getNetworkError () {
          return this.$store.getters[Settings.getters.getNetworkError]
        },
        branchOfficeTabActive () {
          return this.$store.getters[Settings.getters.getSelectedSupplier].id === 0
        },
        contactPersonsTabActive () {
          if (this.$store.getters[Settings.getters.getSupplierBranchOffices] === null) {
            return true
          } else {
            if (this.$store.getters[Settings.getters.getSupplierBranchOffices].length <= 0) {
              return true
            } else {
              return false
            }
          }
        },
        bankAccountsTabActive () {
          if (this.$store.getters[Settings.getters.getSupplierBranchOffices] === null) {
            return true
          } else {
            if (this.$store.getters[Settings.getters.getSupplierBranchOffices].length <= 0) {
              return true
            } else {
              return false
            }
          }
        },
        manufacturerTabActive () {
          if (this.$store.getters[Settings.getters.getSupplierBranchOffices] === null) {
            return true
          } else {
            if (this.$store.getters[Settings.getters.getSupplierBranchOffices].length <= 0) {
              return true
            } else {
              return false
            }
          }
        }
      }
    }
</script>


<style scoped>

    #menu-button {
        margin-top: 4px;
        width: 55px;
        height: 55px;
    }

</style>


// WEBPACK FOOTER //
// src/components/Shared/AddSupplier.vue